export default __webpack_public_path__ + "file/Fiche-EN-Produit-Puroak-Stave-7.asset.64fede66.pdf";